export const BANK_ACCOUNT_TYPES = [
  { value: 'Savings', key: 'Savings' },
  { value: 'Current', key: 'Current' },
];
